export type ArticleBlock =
  | { kind: 'heading'; text: string }
  | { kind: 'text'; text: string }
  | { kind: 'quote'; text: string }
  | { kind: 'image'; src: string; alt: string; caption?: string }
  | { kind: 'video'; src: string; caption?: string }
  | { kind: 'checklist'; items: string[] }
  | { kind: 'callout'; title: string; items: string[] }
  | { kind: 'cta'; label: string }
  | { kind: 'reviews' }

export const paragraphs = (...lines: string[]): ArticleBlock[] =>
  lines.map((text) => ({ kind: 'text', text }))

export interface Testimonial {
  name: string
  age: number
  breed: string
  property: string
  quote: string
  photo: string
}
